import React from 'react';

import slide0 from '../images/prod/gambar-23.png'; 
import slide1 from '../images/camp.png'; 

const Content = () => {
  return (
    <section className="text-gray-600 body-font">
  <div className="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
    <div className="lg:max-w-2xl lg:w-full md:w-1/2 w-5/6 mb-10 md:mb-0">
    <img className="w-full h-full lg:max-w-2xl rounded-lg shadow-md" alt="hero" src={slide0} />
    </div>
    <div className="lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 flex flex-col md:items-start md:text-left items-center text-center">
    <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">Tentang Sekolah Megana
      </h1>
      <br />
      {/* Menjadi Tujuan Sekolah Efektif untuk menggali potensi, minat, dan bakat generasi muda Indonesia sehingga dapat bersaing di kancah internasional. Mempersiapkan para peserta didik untuk dapat diterima di perguruan tinggi negeri (PTN) dan perguruan tinggi terbaik dunia. */}
      <p className="mb-8 leading-relaxed">Sekolah Megana adalah SMA yang fokus mempersiapkan para peserta didik untuk dapat diterima di perguruan tinggi negeri (PTN) dan perguruan tinggi terbaik dunia.
<br /><br />
SMA Megana merupakan Tujuan Sekolah Efektif untuk menggali potensi, minat, dan bakat generasi muda Indonesia sehingga dapat bersaing di kancah internasional.

</p>
    </div>
  </div>
  <div className="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
    <div className="lg:max-w-2xl lg:w-full md:w-1/2 w-5/6 mb-10 md:mb-0">
    <img className="w-full h-full lg:max-w-2xl rounded-lg shadow-md" alt="hero" src={slide1} />
    </div>
    <div className="lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 flex flex-col md:items-start md:text-left items-center text-center">
    <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">Camp Liburan SSB
      </h1>
      <br />
      {/* Menjadi Tujuan Sekolah Efektif untuk menggali potensi, minat, dan bakat generasi muda Indonesia sehingga dapat bersaing di kancah internasional. Mempersiapkan para peserta didik untuk dapat diterima di perguruan tinggi negeri (PTN) dan perguruan tinggi terbaik dunia. */}
      <p className="mb-8 leading-relaxed">Sekolah Megana menawarkan kesempatan bagi para peserta didik untuk bermain bola pagi dan sore di bawah bimbingan pelatih sekolah sepak bola.
<br /><br />
Di siang hari, mereka dapat belajar matematika melalui pendekatan homeschooling Megana.
<br /><br />
Selain itu, Sekolah Megana juga menyelenggarakan seminar interaktif yang bertujuan untuk membentuk budi pekerti dan mengajarkan nilai anak berbakti. Acara ini eksklusif hanya untuk 20 anak yang sehat dan mandiri dengan usia antara 12 hingga 14 tahun. Para peserta juga akan mendapatkan makanan 3 kali sehari dan tinggal di camp dengan fasilitas kamar tidur berbentuk kabin capsul.</p>
    </div>
  </div>
</section>


  );
};

export default Content;
